import { RequiredBehaviors } from 'app/beta-editor/pages/types';

const welcomeBehavior: RequiredBehaviors = {
  label: () => '',
  menuLabel: () => '',
  crumbLabel: () => 'Welcome',
  data: () => {},
  status: () => 'success',
  visible: () => false,
  isClickable: () => false,
  isLocked: () => false,
};

export default welcomeBehavior;
